import { Box, Tooltip, Typography } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { format, parseISO, isValid } from "date-fns";
import CustomStatusChip from "@/components/custom/custom-status-chip";
import { CLOSURE_STATUS_STYLES } from "../../data";

const formatDate = (value) => {
  if (!value) return "N/A";
  const parsed = parseISO(value);
  return isValid(parsed) ? format(parsed, "MMM d, yyyy h:mm a") : value;
};

export const getClosureColumns = (onView) => [
  {
    accessorKey: "accountOwnerName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Account Owner</div>,
    cell: ({ row }) => (
      <Box sx={{ minWidth: 0 }}>
        <Typography fontSize="0.85rem" fontWeight={500} noWrap>
          {row.original.accountOwnerName ?? "N/A"}
        </Typography>
        <Typography fontSize="0.78rem" color="text.secondary" noWrap>
          {row.original.accountOwnerEmail ?? "—"}
        </Typography>
      </Box>
    ),
  },
  {
    accessorKey: "submittedAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Submitted</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.82rem", whiteSpace: "nowrap" }}>
        {formatDate(row.original.submittedAt)}
      </div>
    ),
  },
  {
    accessorKey: "platform",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Platform</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.82rem" }}>{row.original.platform ?? "N/A"}</div>
    ),
  },
  {
    accessorKey: "status",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => (
      <CustomStatusChip status={row.original.status} styles={CLOSURE_STATUS_STYLES} />
    ),
  },
  {
    accessorKey: "blocked",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Blocked</div>,
    cell: ({ row }) =>
      row.original.blocked ? (
        <Tooltip title="Has open items preventing approval" arrow placement="top">
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, color: "error.main" }}>
            <BlockIcon sx={{ fontSize: 16 }} />
            <Typography fontSize="0.8rem" fontWeight={500}>Yes</Typography>
          </Box>
        </Tooltip>
      ) : (
        <Typography fontSize="0.8rem" color="text.secondary">No</Typography>
      ),
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <Typography
        onClick={(e) => { e.stopPropagation(); onView?.(row.original); }}
        sx={{ fontSize: "0.82rem", fontWeight: 600, color: "primary.main", cursor: "pointer" }}
      >
        Review
      </Typography>
    ),
  },
];